import { createSelector } from 'reselect';

import { menu, store } from '../../core/state';
import { GetRestaurantProps } from '../../core/state/store/store.types.d';

interface FindCollectionMenuProps {
  prId: number | string;
  vrId: number | string;
}

interface FindDeliveryMenuProps {
  deliveryLocationId: number | string;
  vrId: number | string;
}
interface FindMenuByUrlProps {
  menuUrl: string;
}

export const findMenu = (state: WebOrder.State, props: GetRestaurantProps) =>
  props.deliveryType === 'collection'
    ? findCollectionMenu(state, props)
    : findDeliveryMenu(state, props);

export const findCollectionMenu = createSelector(
  [
    (state: WebOrder.State, props: FindCollectionMenuProps) =>
      store.selectors.getCollectionSummary(state, props),
    (state: WebOrder.State) => state.flipdish.MenuData,
  ],
  (CollectionSummary, MenuData) => {
    if (!CollectionSummary) {
      return null;
    }
    const menuUrl = CollectionSummary.MenuUrl;

    if (!menuUrl) {
      return null;
    }

    return menu.selectors.getMenuByUrl(MenuData, { menuUrl });
  },
);

export const findDeliveryMenu = createSelector(
  [
    (state: WebOrder.State, props: FindDeliveryMenuProps) =>
      store.selectors.getDeliverySummary(state, props),
    (state: WebOrder.State) => state.flipdish.MenuData,
  ],
  (DeliveryConfig, MenuData) => {
    if (!DeliveryConfig) {
      return null;
    }
    const menuUrl = DeliveryConfig.MenuUrl;

    if (!menuUrl) {
      return null;
    }

    return menu.selectors.getMenuByUrl(MenuData, { menuUrl });
  },
);

export const findMenuByUrl = createSelector(
  [
    (state: WebOrder.State) => state.flipdish.MenuData,
    (_state: WebOrder.State, props: FindMenuByUrlProps) => props.menuUrl,
  ],
  (MenuData, menuUrl) => {
    if (!menuUrl) {
      return null;
    }

    return menu.selectors.getMenuByUrl(MenuData, { menuUrl });
  },
);
